module.exports = __webpack_public_path__ + "static/media/orange-note-text.d156c0d2.svg";